<template>
  <div class="newsList">
    <div class="contentrows_box">
      <div class="contentrows">
        <div v-if="news.length === 0">
          <span style="color: black;font-size:10px;">暂无数据</span>
        </div>
        <div v-if="news.length!=0"><span style="font-size: x-large;color: rgb(137,12,12);font-weight: bold">通知公告</span></div>
        <div class="row_box" v-for="(item,index) in news" :key="index">
          <div class="row">
            <div class="row_date">
              <div class="row_date_left">{{item.day}}</div>
              <div class="row_date_right">
                <div class="row_date_month">{{item.month}}</div>
                <div class="row_date_year">{{item.year}}</div>
              </div>
            </div>
            <div class="row_content">
              <div class="row_title" @click="showAnnounce(item)">{{item.title}}</div>
              <div class="row_name">{{item.uniName}}</div>
            </div>
            <el-button type="primary" @click="showAnnounce(item)">详情</el-button>
          </div>
        </div>
      </div>
      <div class="page" v-if="news.length > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[2, 4, 6, 8,10]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next"
            background
            :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import time from '@/core/time.js';
export default {
  data() {
    return {
      totalNum:0,pageNum:1,pageSize:20,
      news:[],
    }
  },
  watch:{
  },
  created(){
    this.newsSelect();
  },
  mounted(){

  },
  methods:{
    newsSelect(){
      let data = {
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        lang: this.$i18n.locale,
      };
      console.log('==============',data);
      let url = '/ArAnnounce/getAllAnnounce2';
      this.$request.post(url,data).then(data => {
        this.news = data.obj.list;
        this.totalNum = data.obj.total;
        for(let item of this.news){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          // this.$set(item,"year",item.createdDate.substring(0,4));
          // this.$set(item,"month",item.createdDate.substring(5,7));
          // this.$set(item,"day",item.createdDate.substring(8,10));
          item.createdDate = time.formateDate(item.createdDate);
        }
      })
    },
    //改变页码大小
    handleSizeChange(pageSize){
      this.pageSize = pageSize;
      this.newsSelect()
    },
    //跳转页码
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      // console.log(`当前页:`,this.pageNum);
      this.newsSelect()
    },
    showAnnounce(value){
      if(this.$store.getters.userId==null){
        this.$router.push({
          path:'/fannounceShow',
          query:{
            id:value.id,
          }
        })
      }else{
        this.$router.push({
          path:'/announceShow',
          query:{
            id:value.id,
          }
        })
      }
    },

  }
}
</script>
<style lang="less">
.newsList{
  width: 100%;
  height: 100%;
  background: white;
  .contentrows_box{
    height: 90%;
    border-radius:20px;
    background: white;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 2.5%;
    box-shadow: 0px 0px 10px 0 #d0d2d3;
    .contentrows{
      margin:auto;
      width:860px;
      padding-top: 50px;
      .row_box{
        width:860px;
      }
      .row {
        height: 80px;
        width: 840px;
        border-bottom: 2px dotted #D4D4DC;
        .row_date{
          display: flex;
          float: left;
          width: 82px;
          .row_date_left{
            height: 60px;
            margin-top: 20px;
            font-size: 35px;
            line-height: 70px;
          }
          .row_date_right{
            height: 40px;
            margin-top: 34px;
            padding-left: 5px;
            .row_date_month{
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
            .row_date_year{
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
        .row_content{
          margin-top: 40px;
          line-height: 40px;
          height: 30px;
          padding-left: 20px;
          margin-left: 10px;
          width: 600px;
          float: left;
          border-left: 6px solid #CDD9E9;
          .row_title {
            overflow: hidden;
            width: 400px;
            font-size: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow:hidden;
            float: left;
          }
          .row_title:hover{
            cursor: pointer;
          }
          .row_name{
            font-size: 13px;
            width: 200px;
            color: #a8a8ac;
            float: right;
            text-align: right;
          }
        }
        .el-button{
          background: #3A63B3;
          height: 20px;
          width: 80px;
          margin-top: 45px;
          margin-right: 30px;
          font-size: 13px;
          line-height: 2px;
          border-radius:0;
          float: right;
        }
      }

    }
    .page{
      height: 100px;
      width: 860px;
      margin:auto;
      position: relative;
      .el-pager{
        li{
          border: 1px solid #dcdfe6;
          margin-right: 10px;
          background-color: white;
        }
        li:not(.disabled).active{
          background-color: #3A62FE;
          color: white;
        }
        li:hover {
          color: #3A62FE;
        }
      }
      .btn-prev{
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        margin-left: 10px;
        background-color: white;
      }
      .btn-next{
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        background-color: white;
      }
      .el-pagination{
        position: absolute;
        bottom: 30px;
        right: 0;
        .el-pagination__sizes{
          float: right;
          .el-input__inner{
            color: #5D61AA;
            font-weight: bold;
          }
        }
      }
    }
  }
}

</style>
